import React, {
  useCallback, useContext, useEffect, useState,
} from 'react';
import ProcessesView from 'screens/Admin/Processes/components/View';
import AdminContainer from 'components/Admin/AdminContainer';
import ProcessService from 'services/api/Process';
import handlePromise from 'utils/Promise';
import { ModalErrorContext } from 'context/ModalError';

function ProcessesScreen() {
  const { openErrorModal } = useContext( ModalErrorContext );
  const [data, setData] = useState<any[]>( [] );
  const [isLoading, setIsLoading] = useState( true );

  const loadData = useCallback( async () => {
    setIsLoading( true );
    try {
      const [err, response, responseData] = await handlePromise(
        ProcessService.getLatest(),
      );
      if ( !response?.ok ) {
        openErrorModal( err?.toString?.() );
        setData( [] );
        return;
      }
      setData( responseData );
    } finally {
      setIsLoading( false );
    }
  }, [] );

  useEffect( () => {
    loadData();
  }, [loadData] );

  const fetchData = useCallback( () => {}, [] );

  const tableData = {
    data,
    totalItems: data.length,
    pageCount: 1,
  };

  return (
    <AdminContainer>
      <ProcessesView
        data={tableData}
        fetchData={fetchData}
        isLoading={isLoading}
        reloadData={loadData}
      />
    </AdminContainer>
  );
}

export default ProcessesScreen;
